import React from 'react';
import { IconButton, Typography, styled } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SidebarItem from '../SidebarItem';
import { SIDEBAR_WIDTH } from 'constants/constants';
import { useSelector } from 'store/selector';
import { AccountBox, People, Security } from '@mui/icons-material';
import { usePermissionRules } from 'hooks/permissionRules';

const Container = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#fff',
  zIndex: 2,
  transform: `translateX(-${SIDEBAR_WIDTH}px)`,
  transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
});

const DrawerHeader = styled('div')(({ theme }) => ({
  color: theme.palette.text.primary,
  minHeight: 54,
  display: 'flex',
  gap: 8,
  padding: 10,
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(1),
}));

type UserControlSidebarProps = {
  show: boolean;
  handleClose(): void;
};

const UserControlSidebar: React.FC<UserControlSidebarProps> = ({ show, handleClose }) => {
  const user = useSelector(state => state.user);
  const { checkPermission } = usePermissionRules();

  return (
    <Container style={{ transform: show ? 'translateX(0)' : undefined }}>
      <DrawerHeader>
        <IconButton size="small" color="inherit" onClick={handleClose}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Typography color="inherit" variant="h6" fontSize={14} fontWeight={700}>
          Controle de usuário
        </Typography>
      </DrawerHeader>
      {user && (
        <>
          {checkPermission('settings.user-control.users') && (
            <SidebarItem to="/users" icon={<People />} text="Usuários" />
          )}
          {checkPermission('settings.user-control.user-profiles') && (
            <SidebarItem to="/user-profiles" icon={<AccountBox />} text="Perfis de usuário" />
          )}
          {checkPermission('settings.user-control.access-rules') && (
            <SidebarItem to="/access-rules" icon={<Security />} text="Regras de acesso" />
          )}
        </>
      )}
    </Container>
  );
};

export default UserControlSidebar;
